<template>
    <div>
        <button-link @click="open">
            <i class="fa fa-pencil mr-2"></i> Bearbeiten
        </button-link>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template v-slot:header>Einstellungen</template>

                <div class="mb-4">
                    Benutzergruppe: {{ allocation.user_group.name }}<br>
                    Zone: {{ allocation.zone.name }}
                </div>

                <div class="border p-4 border-rounded">
                    <toggle-group v-model="alwaysUsable" class="mb-4">
                        Permanent buchbar
                        <template v-slot:helper>Regel wird immer angewendet.</template>
                    </toggle-group>

                    <input-text v-model="activatedHoursBeforeDay" class="mb-8">
                        Regel wird erst x Stunden vor dem Tag aktiviert.
                        <template v-slot:helper>z.B. 0 - Schreibtische lassen sich nur am gleichen Tag buchen. 24 -
                            Schreibtische lassen sich einen Tag vorher buchen. Leer lassen um zu deaktivieren.
                            Permanent buchbare Regeln sind hiervon ausgenommen.
                        </template>
                    </input-text>

                    <input-text v-model="activatedHoursBeforeWeek" class="mb-8">
                        Regel wird erst x Stunden vor der Woche aktiviert.
                        <template v-slot:helper>z.B. 0 - Schreibtische lassen sich am Montag für die ganze Woche buchen.
                            24 -
                            Schreibtische lassen sich Sonntag für die ganze Woche buchen. Leer lassen um zu
                            deaktivieren.
                            Permanent buchbare Regeln sind hiervon ausgenommen.
                        </template>
                    </input-text>
                    Es greift die erste gültige Regel.
                </div>

                <div class="flex justify-end" v-show="!loading">
                    <button-primary @click="update">Speichern</button-primary>
                </div>

                <loading v-show="loading"></loading>

            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonLink from "../UI/ButtonLink.vue";
import Modal from "../Modal.vue";
import ToggleGroup from "../UI/ToggleGroup.vue";
import InputText from "../UI/InputText.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import Loading from "../UI/Loading.vue";

export default {
    name: "AllocationEdit",

    components: {
        Loading,
        ButtonPrimary,
        InputText,
        ToggleGroup,
        Modal,
        ButtonLink,
    },

    props: ['allocation'],

    data: () => ({
        showModal: false,
        alwaysUsable: null,
        activatedHoursBeforeDay: null,
        activatedHoursBeforeWeek: null,
        loading: false,
    }),

    methods: {
        open() {
            this.showModal = true;
            this.alwaysUsable = this.allocation.always_usable;
            this.activatedHoursBeforeDay = this.allocation.activated_hours_before_day;
            this.activatedHoursBeforeWeek = this.allocation.activated_hours_before_week;
        },
        update() {
            this.loading = true;
            this.$http.put(`/admin/allocations/${this.allocation.id}`, {
                always_usable: this.alwaysUsable,
                activated_hours_before_day: this.activatedHoursBeforeDay,
                activated_hours_before_week: this.activatedHoursBeforeWeek,
            }).then(() => {
                this.loading = false;
                this.$root.$emit('alert', 'Eintrag gespeichert.');
                this.$emit('updated');
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            });
        },
    },
}
</script>

<style scoped>

</style>
